import type { TDatadogErrorLog } from 'utils/datadog/types'

export const CREATE_OWNED_TOPIC_LOG_ERROR: TDatadogErrorLog = {
  from: 'src > pages > SearchTerritoryPage > components > WinninTopicsTab > components > ButtonSearchVideo > index.tsx',
  name: 'Create owned topic',
  message: 'Creates owned topic based on the users search text',
}
